import { withErrorBoundary } from 'app/components/error-boundary';
import { Column } from 'app/design/primitives/box';
import { ListPage } from 'app/design/primitives/page/list';
import { Text } from 'app/design/primitives/text';
import { useOneLoan } from 'app/network/loan';
import type { NavigationScreen } from 'app/types/navigation';
import { useEffect } from 'react';
import { ActivityIndicator, Pressable } from 'react-native';
import { navigateToUserProfile } from '../billboard/navigator-helper';
import MemberCard from '../groups/member-card';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from 'app/utils/web-helpers';

const LoanParticipantsScreenComponent: NavigationScreen<'loan-participants'> = ({ navigation, route }) => {
  const { t } = useTranslation('loanParticipants');

  const { data: loan, isLoading, isRefetching, refetch } = useOneLoan(route.params.loanId);

  const setPageTitle = usePageTitle('loanParticipants');
  useEffect(() => setPageTitle('title'), [setPageTitle]);

  const users = loan?.participants ?? [];

  return (
    <ListPage
      ItemSeparatorComponent={() => <Column marginTop="spacing.general.x8" />}
      ListEmptyComponent={isLoading ? <ActivityIndicator /> : null}
      ListHeaderComponent={
        <Text fontWeight="600" marginBottom="spacing.general.x8" textAlign="center" variant="headerXSmall">
          {t('title')}
        </Text>
      }
      data={users}
      onRefresh={() => void refetch()}
      refreshing={isRefetching}
      renderItem={({ item }) => (
        <Pressable
          onPress={() =>
            navigateToUserProfile(navigation, item.user.id, loan?.listing.id, loan?.listing.type, item.channelURL)
          }
        >
          <MemberCard
            {...item.user}
            subtext={t('subscriptionsSection.participants', {
              ns: 'one-listing',
              count: item.numParticipants,
            })}
          />
        </Pressable>
      )}
    />
  );
};

export const LoanParticipantsScreen: NavigationScreen<'loan-participants'> = withErrorBoundary(
  LoanParticipantsScreenComponent,
);
